// extracted by mini-css-extract-plugin
export default {"acc":"Accordion_acc__KJ0To","button__wrapper":"Accordion_button__wrapper__J4mtX","content":"Accordion_content__VVXPt","arrow__wrapper":"Accordion_arrow__wrapper__Fu0b2"};